import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

/**
 * The FA(3) document kind as an outline badge with a localized label — the write-side counterpart of the
 * Issued view's `TypeBadge`. A margin invoice is a `STANDARD` kind too, so the label comes from the
 * ({@link kind}, {@link taxScheme}) pair rather than the kind alone: it reads "VAT marża" instead of "VAT".
 */
export function DocumentKindBadge({
  kind,
  taxScheme,
}: {
  kind?: string | null;
  taxScheme?: string | null;
}) {
  const { t } = useTranslation();
  if (!kind) return null;
  const key = kind === 'STANDARD' && taxScheme === 'MARGIN' ? 'STANDARD_MARGIN' : kind;
  return (
    <Badge variant="outline" className="font-normal">
      {t(`invoices.document_kind.${key}`, { defaultValue: kind })}
    </Badge>
  );
}
